export default (theme) => {
  return {
    button: {
      zIndex: 1,
      color: theme.palette.grey[400],
    },
  }
}
